import { useSyncExternalStore } from 'react';

// Recovery credentials live only in this page's memory. Reloads and checkout
// returns require reauthentication rather than persisting a bearer credential.
let token = '';
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
const getSnapshot = () => token;

export function setBillingRecoveryToken(value: string): void {
  token = value;
  // Remove credentials saved by older versions without reading them back.
  try { sessionStorage.removeItem('quantis-billing-recovery'); } catch { /* Storage may be disabled. */ }
  listeners.forEach(listener => listener());
}

export function useBillingRecoveryToken(): string {
  return useSyncExternalStore(subscribe, getSnapshot, () => '');
}
